import setShippingAddress from './setShippingAddress';

export default setShippingAddress;
